import { render, staticRenderFns } from "./AccountResetCard.vue?vue&type=template&id=4ebc2fd4&scoped=true"
import script from "./AccountResetCard.vue?vue&type=script&lang=ts"
export * from "./AccountResetCard.vue?vue&type=script&lang=ts"
import style0 from "./AccountResetCard.vue?vue&type=style&index=0&id=4ebc2fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc2fd4",
  null
  
)

export default component.exports